import React from 'react';
import PropTypes from 'prop-types';

import { MyModal } from '../common';

// import Button from '../common/Button';
import './LoadingModal.scss';
import SavviLoading from '../SavviLoading/SavviLoading';

// import { Link } from 'react-router-dom';

// Modal.setAppElement('#root');

const LoadingModal = ({ isOpen, loadingText }) => {
  const customStyles = {
    overlay: {
      zIndex: 9,
      backgroundColor: 'rgba(0,0,0,.75)',
      position: 'fixed',
      height: '100vh',
      width: '100vw',
      display: 'flex',
      overflowY: 'auto',
      paddingTop: 20,
      WebkitOverflowScrolling: 'touch',
    },
    content: {
      position: 'static',
      maxWidth: '450px',
      minHeight: '175px',
      margin: 'auto',
      padding: 0,
      border: 'none',
      borderRadius: 16,
      backgroundColor: 'transparent',
      boxShadow: '3px 3px 3px 3px #33373859',
      display: 'flex',
      flexDirection: 'column',
    },
  };

  return (
    <MyModal isOpen={isOpen} style={customStyles}>
      <div className="loadingModal">
        <SavviLoading color="manilla" size="md" />
        {loadingText && <h2>{loadingText}</h2>}
      </div>
    </MyModal>
  );
};

LoadingModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  loadingText: PropTypes.string,
};

LoadingModal.defaultProps = {
  isOpen: false,
};

export default LoadingModal;
